function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 24",
  transform: "translate(-861.037 -4244)"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 5",
  cx: 41,
  cy: 40,
  rx: 41,
  ry: 40,
  transform: "translate(861.037 4244)",
  fill: "#002f4d"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Icon feather-repeat",
  fill: "none",
  stroke: "#e8f6f4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 23",
  d: "M912.889 4268l6 6-6 6"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 24",
  d: "M885.186 4283v-3c0-3.314 3.353-6 7.49-6h26.21"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 25",
  d: "M891.186 4301l-6-6 6-6"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 26",
  d: "M918.886 4286v3c0 3.314-3.353 6-7.49 6h-26.21"
})));
var SvgTrialRunIcon = function SvgTrialRunIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 82 80"
  }, props), _ref);
};
export default SvgTrialRunIcon;